export class RegexContainer {
    static numbersOnlyRegex() {
        return /^[0-9]/;
    }

    static removeEmptySpaceRegex() {
        return /\s/g;
    }
}